import { render, staticRenderFns } from "./subject-list.vue?vue&type=template&id=9a4a7dc0&scoped=true&"
import script from "./subject-list.vue?vue&type=script&lang=ts&"
export * from "./subject-list.vue?vue&type=script&lang=ts&"
import style0 from "./subject-list.vue?vue&type=style&index=0&id=9a4a7dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4a7dc0",
  null
  
)

export default component.exports